import React, { useEffect, useState, useCallback, Fragment } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { icon_bridge_people } from 'components/base/images';
import { useShallowAppSelector } from 'store/hooks';
import { IProjectInfo } from 'lib/types/projectTypes';
import { appList } from 'lib/mapper';
import { AppActions, BaseActions, FileActions, ProjectActions } from 'store/actionCreators';
import AlertModalContent from 'components/common/modal/contents/AlertModalContent';
import cx from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';
import Fade from '@material-ui/core/Fade';
import { useDidUpdateEffect } from 'lib/utils';
import { useHistory } from 'react-router-dom';
import { isClinicUserSelector } from 'store/modules/user';
import { IconButton, makeStyles, withStyles } from '@material-ui/core';
import { T } from 'components/common/text';
import CustomSpan from 'components/common/text/CustomSpan';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ClinicModal from 'components/common/modal/ClinicModal';
import { useTranslation } from 'react-i18next';
import CustomText from 'components/common/text/CustomText';
import { IVolumeOver, IVolumeOverResponse } from 'lib/types/utilTypes';
import { color } from 'styles/utils';
import CircularLoading from 'components/base/loading/CircularLoading';
import { useProjectDetailStore } from 'store/local/projectDetail';

const ExcuteApps = () => {
  const {
    projectData,
    hasAlarm,
    projectFilesData: { fileData },
    projectFilesSuccess,
    isReScan,
    isClinicUser,
    installedAppList,
  } = useShallowAppSelector(state => ({
    projectFilesData: state.file.projectFiles.data || {},
    projectFilesSuccess: state.file.projectFiles.success,
    projectData: state.project.project.data,
    hasAlarm: state.project.hasAlarm,
    isReScan: state.base.isReScan,
    isClinicUser: isClinicUserSelector(state),
    installedAppList: state.base.installedAppList,
  }));
  const { t } = useTranslation();
  const projectInfo: IProjectInfo = projectData?.projectInfo;
  const [installedList, setInstalledList] = useState<string[]>(installedAppList);
  const { ipcRenderer } = window;

  const [clickBlock, setClickBlock] = useState<boolean>(false);
  const [isScanClick, setIsScanClick] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [isOverRootDisk, setIsOverRootDisk] = useState<boolean>(false);
  const [overVolumeData, setOverVolumeData] = useState<IVolumeOver[]>([]);
  const [storageRemoveProgress, setStorageRemoveProgress] = useState<boolean>(false);
  const { isPhotogrammetry } = useProjectDetailStore();

  const history = useHistory();

  const handleCloseModal = () => {
    setOpenModal(false);
    setClickBlock(false);
  };

  const handleDeleteStorage = async () => {
    setStorageRemoveProgress(true);

    const res: { status: boolean } = await ipcRenderer.invoke(
      'deleteScanIOSRecoveryBackupAuto',
      {},
    );
    if (res.status) {
      setStorageRemoveProgress(false);
      setClickBlock(false);
      setOpenModal(false);
    } else {
      AppActions.add_popup({
        isOpen: true,
        isCloseIcon: true,
        title: '',
        content: (
          <AlertModalContent title="Alert" mainText={t('MSG_BACKUP_RECOVERY_REMOVE_FIAL')} />
        ),
        onClick() {
          //  setStorageRemoveProgress(false);
        },
        onCancel() {
          //  setStorageRemoveProgress(false);
        },
      });
      setStorageRemoveProgress(false);
      setClickBlock(false);
      // setOpenModal(false);
    }
  };

  const notUsedServiceInBrowser = () => {
    AppActions.add_popup({
      isOpen: true,
      isCloseIcon: true,
      title: '',
      content: (
        <AlertModalContent
          title="Alert"
          mainText="This Service not used in browser."
          subText="Sync Program only."
        />
      ),
      onClick() {
        return;
      },
      onCancel() {
        return;
      },
    });
  };

  const checkStorageOver = (list: IVolumeOver[]) => {
    console.log('HDS] checkStorageOver _______ ', list);
    if (list.find((item: IVolumeOver) => item.msg === 'ROOT_DISK_VOLUME_OVER')) {
      setIsOverRootDisk(true);
    }
    setOverVolumeData(list);
    setOpenModal(true);
  };

  const handleCheckScanIOSVolume = async ({
    appName,
    projectCode,
    projectId,
    isPIM,
  }: {
    appName: string;
    projectCode: string;
    projectId: string;
    isPIM: 0 | 1;
  }) => {
    const res: IVolumeOverResponse = await ipcRenderer.invoke(
      'scanIOSRecoveryBackupVolumeCheck',
      {},
    );
    console.log('HDS] scanIOSRecoveryBackupVolumeCheck _______ ', res);
    if (res.status && res.overList.length === 0) {
      console.log('HDS] ScanIOSVolume 체크 [성공] executeApp IPC 실행');
      console.log('HDS] ScanIOSVolume 체크 [성공] isPIM , ', isPIM);

      ipcRenderer.send('executeApp', {
        appName,
        projectCode,
        projectId,
        isPIM: isPIM,
      });
    } else {
      console.log('HDS] ScanIOSVolume 체크 [실패] 팝업 실행');
      checkStorageOver(res.overList);
    }
  };

  const handleClickApp = useCallback(
    (appName: string, isPIM?: boolean) => {
      if (!ipcRenderer) {
        notUsedServiceInBrowser();
      } else {
        console.log('HDS] handleClickApp 앱 클릭 최초 실행 ');
        handleSendExcuteApp({
          appName,
          projectCode: projectInfo?.projectCode,
          projectId: projectInfo?.projectId,
          isPIM: !!isPIM ? 1 : 0,
        });
        setClickBlock(true);
      }
    },
    [projectInfo],
  );

  const handleSendExcuteApp = ({
    appName,
    projectCode,
    projectId,
    isPIM,
  }: {
    appName: string;
    projectCode: string;
    projectId: string;
    isPIM?: 0 | 1 | undefined;
  }) => {
    console.log('PMS] handleSendExcuteApp 앱 분기 처리');
    console.log(
      'HDS] handleSendExcuteApp , ',
      appName,
      ', ',
      projectCode,
      ', ',
      projectId,
      ', ',
      isPIM,
    );

    if (appName !== 'APP_SCAN_IOS') {
      console.log('PMS] IOS [ X ] -> executeApp 실행');
      ipcRenderer.send('executeApp', {
        appName,
        projectCode,
        projectId,
      });
    } else {
      console.log('PMS] IOS [ O ] -> 볼륨 체크');
      handleCheckScanIOSVolume({
        appName: 'APP_SCAN_IOS',
        projectCode: projectInfo?.projectCode,
        projectId: projectInfo?.projectId,
        isPIM: !!isPIM ? 1 : 0,
      });
    }
  };

  useDidUpdateEffect(() => {
    if (!isScanClick) return;
    if (!projectFilesSuccess) return;
    console.log('PMS] fileData __________ ', fileData.scanFileList);
    console.log('HDS] 스캔 자동 시작 ____ 볼륨 체크');
    handleSendExcuteApp({
      appName: 'APP_SCAN_IOS',
      projectCode: projectInfo?.projectCode,
      projectId: projectInfo?.projectId,
    });
    BaseActions.is_re_scan(false);
    setIsScanClick(false);
  }, [projectFilesSuccess, fileData, projectInfo, isScanClick]);

  useEffect(() => {
    console.log('PMS] isReScan ____________ ', isReScan);
    if (isReScan) {
      console.log('HDS] isReScan 스캔 자동 시작 ____ 볼륨 체크');
      handleSendExcuteApp({
        appName: 'APP_SCAN_IOS',
        projectCode: projectInfo?.projectCode,
        projectId: projectInfo?.projectId,
        isPIM: !!isPhotogrammetry ? 1 : 0,
      });
      BaseActions.is_re_scan(false);
    }
  }, [isReScan, isPhotogrammetry]);

  useEffect(() => {
    if (ipcRenderer) {
      if (!!projectInfo?.projectCode) {
        ipcRenderer.on('executeAppRes', (e: any, data: any) => {
          console.log('HDS] executeAppRes _________ ', JSON.stringify(data));
          setTimeout(() => {
            // NOTE: 연속 클릭 방지
            setClickBlock(false);
          }, 1000);
          // NOTE: 앱 실행 시, Project Store에 저장 -> project stage 변경 시 사용
          if (data.status === 'start') {
            const progressFlag = appList.find(
              (item: any) => item.code === data.appName,
            )?.progressFlag;
            const submitData = {
              appName: data.appName,
              progressFlag: progressFlag,
              projectCode: projectInfo.projectCode,
            };
            ProjectActions.set_excuteapp_timeline(submitData);
          }
          // alert('[Appname : ' + data.appName + ',  status : ' + data.status + ' ]');
        });
      }
    }
  }, [projectInfo]);

  useEffect(() => {
    if (ipcRenderer) {
      ipcRenderer.send('installedAppList', {});
      ipcRenderer.on('installedAppListRes', (e: any, data: any) => {
        setInstalledList(data.appList);
      });
    }
  }, []);

  const handleOpenBridge = () => {
    if (!ipcRenderer) return;
    ipcRenderer.send('openBrowser', {
      url: 'https://www.dofbridge.com/home',
    });
  };

  const tooltipStyle = withStyles({
    tooltipPlacementTop: {
      fontSize: 14,
      fontWeight: 400,
      padding: '10px 15px',
      borderRadius: 10,
      backgroundColor: '#25256F',
      // padding: 10px 15px;
      // border-radius: 10px;
      // background-color: #25256F;
    },
  });

  // const classess = tooltipStyle();
  return (
    <Styled.ExcuteNav data-component-name="ExcuteApps">
      <h2 className="sr-only">Excute App</h2>
      <ClinicModal
        title={t('GLOBAL_ANNOUNCEMENT')}
        isOpen={openModal}
        onClose={handleCloseModal}
        onCancel={isOverRootDisk ? null : handleCloseModal}
        onConfirm={isOverRootDisk ? handleCloseModal : handleDeleteStorage}
      >
        <StorageCheckModal
          overVolumeData={overVolumeData}
          isOverRootDisk={isOverRootDisk}
          storageRemoveProgress={storageRemoveProgress}
        />
      </ClinicModal>

      <div className="excuteApps__container">
        <ul className="excuteApps__item_list">
          {appList?.map((item, idx) => {
            const isInstalled = !!installedList?.find((appName: any) => appName === item.code);
            if (!isInstalled) return;
            if (item.code === 'APP_BASEAPP') return;
            if (item.code === 'APP_MOTIONAPP') return;
            // if (!!isClinicUser && item.code === 'APP_SCAN_MODEL_SCANNER') return;
            if (!!isClinicUser && item.code === 'APP_SCAN_IOS') return;
            // const;
            return (
              <Fragment key={idx}>
                <StyledTooltip
                  className="excuteApps__tooltip"
                  title={item.name}
                  placement="top"
                  arrow
                  TransitionComponent={Fade}
                  TransitionProps={{ timeout: 300 }}
                >
                  <li className="excuteApps__item_box">
                    <div
                      className={cx('excuteApps__item', {})}
                      onClick={() => {
                        if (hasAlarm) return;
                        if (!clickBlock) handleClickApp(item.code);
                      }}
                    >
                      {!!item.icon ? (
                        <img src={item.icon} className="excuteApps__item_icon" alt="app icon" />
                      ) : (
                        <div className="excuteApps__item_icon empty"></div>
                      )}
                    </div>
                  </li>
                </StyledTooltip>
                <div className="item_line"></div>
                {/* {idx > 0 && <div className="item_line"></div>} */}
              </Fragment>
            );
          })}
          <StyledTooltip
            className="excuteApps__tooltip"
            title={'Dof Bridge'}
            placement="top"
            arrow
            TransitionComponent={Fade}
            TransitionProps={{ timeout: 300 }}
          >
            <li className="excuteApps__item_box">
              <div
                className="excuteApps__item"
                onClick={() => {
                  if (hasAlarm) return;
                  handleOpenBridge();
                }}
              >
                <img src={icon_bridge_people} className="excuteApps__item_icon" alt="app icon" />
              </div>
            </li>
          </StyledTooltip>
        </ul>
      </div>
      {isClinicUser && (
        <div className="excuteApps__scan_button_box">
          <IconButton
            className="excuteApps__scan_button"
            disabled={!installedList?.find((appName: any) => appName === 'APP_SCAN_IOS')}
            onClick={() => {
              if (!clickBlock) handleClickApp('APP_SCAN_IOS', isPhotogrammetry);
            }}
          >
            <div className="excuteApps__scan_button_icon">
              <PhotoCameraIcon />
              <CustomSpan fontSize={20} fontWeight={600}>
                <T>PROCESS_SCAN</T>
              </CustomSpan>
            </div>
            <ArrowForwardIcon />
          </IconButton>
        </div>
      )}
    </Styled.ExcuteNav>
  );
};

const StyledTooltip = withStyles({
  tooltipPlacementTop: {
    fontSize: 14,
    fontWeight: 400,
    padding: '10px 15px',
    borderRadius: 10,
    backgroundColor: '#25256F',
  },
  arrow: {
    color: '#25256F',
  },
})(Tooltip);

const Styled = {
  ExcuteNav: styled.div`
    display: flex;
    column-gap: 16px;
    justify-content: flex-end;
    .excuteApps__container {
      background-color: #fff;
      border: 1px solid #e1e1e7;
      border-radius: 10px;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      .excuteApps__item_list {
        display: flex;
        align-items: center;
        .excuteApps__item_box {
          width: 60px;
          height: 53px;
          padding: 5px;
          margin: 0 10px;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          .excuteApps__item {
            scale: 1;
            transition-duration: 150ms;
            transition-property: scale;
            width: 40px;
            height: 40px;
            &:hover {
              cursor: pointer;
              scale: 1.4;
            }
            .excuteApps__item_icon {
              width: 100%;
              height: 100%;
              &.empty {
                border: 1px solid #e1e1e7;
                border-radius: 2px;
              }
            }
          }
        }
        .item_line {
          width: 1px;
          height: 24px;
          background-color: #e1e1e7;
        }
      }
    }

    .excuteApps__scan_button_box {
      .excuteApps__scan_button {
        width: 200px;
        height: 80px;
        padding: 10px 20px;
        color: #fff;
        background-color: #00a6e2;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .excuteApps__scan_button_icon {
          display: flex;
          align-items: center;
          column-gap: 10px;
        }

        &.Mui-disabled {
          background-color: #a6a8b1;
        }
      }
    }
  `,
};

interface StorageCheckModalProps {
  overVolumeData: IVolumeOver[];
  isOverRootDisk: boolean;
  storageRemoveProgress: boolean;
}

const StorageCheckModal = ({
  overVolumeData,
  isOverRootDisk,
  storageRemoveProgress,
}: StorageCheckModalProps) => {
  return (
    <StyledStorageCheckModal data-component-name="StorageCheckModal">
      {isOverRootDisk ? (
        <div className="storageCheckModal__disk_over_container">
          <div className="storageCheckModal__disk_over">
            {overVolumeData?.map((item: IVolumeOver) => {
              if (item.msg !== 'ROOT_DISK_VOLUME_OVER') return;
              return (
                <div className="storageCheckModal__disk_over_row">
                  <CustomText
                    fontSize={16}
                    fontColor="#444"
                    fontWeight={400}
                    fontStyle={{ lineHeight: 24 }}
                  >
                    <T>{item.volumeType}</T>
                  </CustomText>
                  <CustomText
                    fontSize={16}
                    fontColor="#444"
                    fontWeight={400}
                    fontStyle={{ lineHeight: 24 }}
                  >
                    :
                  </CustomText>
                  <CustomText
                    fontSize={16}
                    fontColor="#444"
                    fontWeight={400}
                    fontStyle={{ lineHeight: 24 }}
                  >
                    {item.path}
                  </CustomText>
                </div>
              );
            })}
          </div>
          <CustomText
            fontSize={16}
            fontColor="#444"
            fontWeight={400}
            fontStyle={{ lineHeight: 24 }}
          >
            <T>MSG_ROOT_DISK_VOLUME_OVER</T>
          </CustomText>
        </div>
      ) : (
        <div className="storageCheckModal__storage_over_container">
          <div className="storageCheckModal__storage_over">
            <CustomText
              fontSize={16}
              fontColor="#444"
              fontWeight={400}
              fontStyle={{ lineHeight: 24 }}
            >
              <T>MSG_STORAGE_VOLUME_OVER</T>
            </CustomText>

            {overVolumeData?.map((item: IVolumeOver) => {
              const isOver = item.usage >= item.volume;
              if (item.msg === 'ROOT_DISK_VOLUME_OVER') return;
              return (
                <div className="storageCheckModal__storage_over_row">
                  <CustomText
                    fontSize={16}
                    fontColor="#444"
                    fontWeight={400}
                    fontStyle={{ lineHeight: 24 }}
                  >
                    <T>{item.volumeType}</T>
                  </CustomText>
                  <div className="storage_volume_box">
                    <span>{'('}</span>
                    <CustomText
                      fontSize={16}
                      fontColor="#444"
                      fontWeight={400}
                      fontStyle={{ lineHeight: 24 }}
                    >
                      {item.volume}
                    </CustomText>
                    <span>{'/'}</span>
                    <CustomText
                      fontSize={16}
                      fontColor={isOver ? color.red : '#444'}
                      fontWeight={400}
                      fontStyle={{ lineHeight: 24 }}
                    >
                      {item.usage}
                    </CustomText>
                    <span>{')'}</span>
                  </div>
                </div>
              );
            })}
            <CustomText
              fontSize={16}
              fontColor="#444"
              fontWeight={400}
              fontStyle={{ lineHeight: 24 }}
            >
              <T>SYSTEM_SECURE_STORAGE_VOLUME_QUESTION</T>
            </CustomText>
          </div>
          <div className="storageCheckModal__delete_noti">
            <div className="circle_exclamation_mark">
              <span>!</span>
            </div>
            <CustomText
              fontSize={16}
              fontColor={color.red}
              fontWeight={400}
              fontStyle={{ lineHeight: 24 }}
            >
              <T>SYSTEM_STORAGE_VOLUME_NOTIFICATION</T>
            </CustomText>
          </div>
        </div>
      )}

      {storageRemoveProgress && (
        <div className="storageCheckModal__progress_box">
          <div className="storageCheckModal__progress_back"></div>
          <div className="storageCheckModal__progress">
            <CircularLoading size={60} />
          </div>
        </div>
      )}
    </StyledStorageCheckModal>
  );
};

const StyledStorageCheckModal = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  position: relative;
  .storageCheckModal__disk_over {
    margin-bottom: 20px;

    .storageCheckModal__disk_over_row {
      display: flex;
      column-gap: 10px;
      margin-bottom: 10px;
    }
  }
  .storageCheckModal__storage_over_container {
    display: flex;
    flex-direction: column;
    row-gap: 30px;
    .storageCheckModal__storage_over {
      display: flex;
      flex-direction: column;
      row-gap: 10px;
      .storageCheckModal__storage_over_row {
        display: flex;

        .storage_volume_box {
          display: flex;
        }
      }
    }
  }

  .storageCheckModal__delete_noti {
    display: flex;
    column-gap: 10px;
    .circle_exclamation_mark {
      font-size: 15px;
      font-weight: 700;
      width: 20px;
      height: 20px;
      border-radius: 10px;
      border: 1px solid ${color.red};
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${color.red};
      margin-left: 10px;
      text-align: center;
      span {
        margin-left: -1px;
        margin-bottom: -2px;
      }
    }
  }
  .storageCheckModal__progress_box {
    z-index: 9999;
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: transparent;
    .storageCheckModal__progress_back {
      background-color: #000;
      opacity: 0.2;
      width: 100%;
      height: 100%;
    }
    .storageCheckModal__progress {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;

export default React.memo(ExcuteApps);
